<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 31.73 35.09" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><rect height="34.09" rx="3.87" width="30.73" x=".5" y=".5"/><path d="m5.33 5.61h20.77v24h-20.77z"/><circle cx="15.62" cy="10.96" r="1.05"/><circle cx="15.62" cy="24.25" r="1.05"/><circle cx="15.62" cy="17.54" r="1.05"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
